import { NavigationItem } from '../components/ui/VerticalNavigation/VerticalNavigation.types';
import { PATHS } from './Paths.constants';
import {
  DashboardIcon,
  AiSystemIcon,
  UserManagementIcon,
  SettingsIcon,
} from '../icons/SvgIcons';

export const navigationItems: NavigationItem[] = [
  {
    name: 'Dashboard',
    href: PATHS.DASHBOARD,
    icon: DashboardIcon,
    current: false,
  },
  {
    name: 'AI Systems',
    href: PATHS.AI_SYSTEMS,
    icon: AiSystemIcon,
    current: false,
  },
  {
    name: 'User Management',
    href: PATHS.USER_MANAGEMENT,
    icon: UserManagementIcon,
    current: false,
  },
  // {
  //   name: "Audit Log",
  //   href: PATHS.AUDIT_LOG,
  //   icon: AuditLogIcon,
  //   current: false,
  // },
  {
    name: 'Settings',
    href: PATHS.SETTINGS,
    icon: SettingsIcon,
    current: false,
  },
];
